import { render, staticRenderFns } from "./One.vue?vue&type=template&id=50a621ae&"
import script from "./One.vue?vue&type=script&lang=js&"
export * from "./One.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports